import { lazy } from "react";

export { TASKS_LIST_PATH, TABS } from "./path";
export const Tasks = lazy(() => import("./page"));
